import * as React from 'react';
import { ProductRowStyles as S } from './ProductRow.styles';

const ProductRowSkeleton: React.FunctionComponent = () => {
  return (
    <S.SkeletonContainer>
      <S.SkeletonMedia />
    </S.SkeletonContainer>
  );
};

export default ProductRowSkeleton;
